import React, { createRef } from "react";
import './CategoryButton.css';
import $ from 'jquery';
import {ReactComponent as Arrow} from "../../../resources/images/arrow.svg";
import {ReactComponent as Dots} from "../../../resources/images/dots.svg";
import { AppUtils } from "../../../utils/AppUtils";
import CloseMenuIcon from "../../../resources/wrappers/menu/CloseMenuIcon";
import { CategoryButtonProps } from "./CategoryButtonProps";
import { Button, Radio, TextField } from "@material-ui/core";
import colors from '../../../utils/colors.json';
import _ from 'lodash';
import { eventDispatcher } from "../../../services/events/EventDispatcher";
import { EventType } from "../../../services/events/EventType";
import { ICategoryDto } from "../../../models/CategoryDto";
import { EventWithData } from "../../../services/events/EventWithData";
import { sessionStorageInstance } from '../../../services/storage/Storage';

export class CategoryButton extends React.Component<CategoryButtonProps, any> {
    readonly MAX_CATEGORY_NAME_LENGTH = 30;
    private newCategoryNameInput: any;
    private updateCategoryNameInput: any;
    private eventSubscription: any = null;
    private eventAndDataSubscription: any = null;
    constructor(props: any){
        super(props);
        this.state = {
            menuOpened: false,
            categoryId: "",
            topNewCategoryMenu: 0,
            leftNewCategoryMenu: 0,
            newCategoryNameRemainingLength: this.MAX_CATEGORY_NAME_LENGTH,
            newCategoryName: "",
            newCategoryColor: "#2E7FF9",
            buttonNewCategoryDisabled: true,
            errorNewCategoryCreationAlreadyExists: false,
            errorNewCategoryCreationGeneric: false,
            menuCategoryOpened: false,
            menuUpdateOpened: false,
            topCategoryMeatballMenu: 0,
            leftCategoryMeatballMenu: 0,
            updateCategoryName: "",
            updateCategoryColor: "",
            buttonUpdateCategoryDisabled: true,
            errorUpdateCategoryAlreadyExists: false,
            errorUpdateCategoryGeneric: false,
            updateCategoryNameRemainingLength: 0,
            copyFunction: false
        }
        
        this.newCategoryNameInput = createRef();
        this.updateCategoryNameInput = createRef();
        this.handleNewCategoryNameKeyDown = this.handleNewCategoryNameKeyDown.bind(this);
        this.handleNewCategoryNameChanges = this.handleNewCategoryNameChanges.bind(this);
        this.handleNewCategoryColorChanges = this.handleNewCategoryColorChanges.bind(this);
        this.handleUpdateCategoryNameKeyDown = this.handleUpdateCategoryNameKeyDown.bind(this);
        this.handleUpdateCategoryNameChanges = this.handleUpdateCategoryNameChanges.bind(this);
        this.handleUpdateCategoryColorChanges = this.handleUpdateCategoryColorChanges.bind(this);
    }

    componentDidMount(){
        this.eventSubscription = eventDispatcher.getEventObserver().subscribe((event: EventType) => {
            if (EventType.OPEN_NEW_CATEGORY_POPUP === event) {
                if(AppUtils.isPhoneOrTablet()){
                    this.openNewCategoryMenu(true);
                } else {
                    this.openNewCategoryMenu();
                }
            } else if(EventType.CLOSE_NEW_CATEGORY_POPUP === event){
                this.closeNewCategoryMenu();
            } else if(EventType.ERROR_NEW_CATEGORY_POPUP_ALREADY_EXISTS === event){
                this.setState({errorNewCategoryCreationAlreadyExists: true});
                this.setState({errorNewCategoryCreationGeneric: false});
                this.setState({buttonNewCategoryDisabled: true});
            } else if(EventType.ERROR_NEW_CATEGORY_POPUP_GENERIC_ERROR === event){
                this.setState({errorNewCategoryCreationGeneric: true});
                this.setState({errorNewCategoryCreationAlreadyExists: false});
                this.setState({buttonNewCategoryDisabled: true});
            } else if(EventType.CLOSE_CATEGORY_POPUP === event){
                this.closeMeatballMenu();
            } else if(EventType.ERROR_UPDATE_CATEGORY_POPUP_ALREADY_EXISTS === event){
                this.setState({errorUpdateCategoryAlreadyExists: true});
                this.setState({errorUpdateCategoryGeneric: false});
                this.setState({buttonUpdateCategoryDisabled: true});
            } else if(EventType.ERROR_UPDATE_CATEGORY_POPUP_GENERIC_ERROR === event){
                this.setState({errorUpdateCategoryAlreadyExists: false});
                this.setState({errorUpdateCategoryGeneric: true});
                this.setState({buttonUpdateCategoryDisabled: true});
            }
        }, () => {
            // Nothing to do 
        });

        this.eventAndDataSubscription = eventDispatcher.getEventAndDataObserver().subscribe((eventWithData: EventWithData) => {
            if(eventWithData.eventType === EventType.ERROR_COPY_CATEGORY){
                console.log(JSON.stringify(eventWithData));
                this.setState({copyFunction: true});
                let failedName = eventWithData.data.failedName;
                let category = eventWithData.data.category;
                let place = eventWithData.data.place;
                if(this.state.categoryId === category.categoryId){
                    this.openCopyMenu(category, place, failedName);
                }
            }
        }, () => {
            // Nothing to do 
        });

        this.setState({categoryId: this.props.category?.categoryId});

        window.addEventListener('resize', () => {this.handleResizeViewForActionsMenu()});
    }

    componentWillUnmount(){
        if(this.eventSubscription !== null){
            this.eventSubscription.unsubscribe();
        }

        if(this.eventAndDataSubscription !== null){
            this.eventAndDataSubscription.unsubscribe();
        }

        window.removeEventListener('resize', () => {this.handleResizeViewForActionsMenu()});
    }

    // ------ NEW CATEGORY Management
    private openNewCategoryMenu(scrollTo?: boolean){
        if(this.state.menuOpened === false){
            let main = $('#main-container-catalog')
            let mainHeight = main!!.height();

            if(!AppUtils.isPhoneOrTablet()){
                // desktop
                let left = $('#category-create-new-button').offset()?.left !== undefined ? $('#category-create-new-button').offset()?.left : 0;
                let top = $('#category-create-new-button').offset()?.top;
                let place = this.props.place;
    
                if(place === 1){
                    // left column, use right
                    if(left!! > 0){
                        // 294 + 2 border is the widht of the category button
                        // 10 is the margin from button and container
                        left = left!! + 296 + 10;
                    }
                    this.setState({topNewCategoryMenu: top});
                    this.setState({leftNewCategoryMenu: left});
                } else if(place === 2){
                    // center column, use right
                    if(left!! > 0){
                        // 294 + 2 border is the widht of the category button
                        // 10 is the margin from button and container
                        left = left!! + 296 + 10;
                    }
                    this.setState({topNewCategoryMenu: top});
                    this.setState({leftNewCategoryMenu: left});
                } else {
                    // right column, use left
                    if(left!! > 0){
                        // 335 is the widht of the new container
                        // 10 is the margin from button and container
                        left = left!! - 335 - 10;
                    }
                    this.setState({topNewCategoryMenu: top});
                    this.setState({leftNewCategoryMenu: left});
                }

                main.height(mainHeight!!.toString());

                window.scrollTo({
                    top: $("#category-create-new-button").offset()?.top,
                    behavior: 'smooth'
                });
            } else {
                // mobile, on top of the button category
                let top = $('#category-create-new-button').offset()?.top;
                let newTop = top!! - (373 + 5);
                this.setState({topNewCategoryMenu: newTop});
                this.setState({leftNewCategoryMenu: 20});

                if(scrollTo){
                    let topButton = $("#category-create-new-button").offset()?.top !== undefined ? $("#category-create-new-button").offset()?.top! : 0;
                    let computedTop = (topButton > 373) ?  (topButton - 373) : topButton;
                    window.scrollTo({
                        top: computedTop,
                        behavior: 'smooth'
                    });
                }
            }

            this.setState({menuOpened: true}, () => {
                this.setState({errorNewCategoryCreationAlreadyExists: false});
                this.setState({errorNewCategoryCreationGeneric: false});
            });
        }
    }

    private closeNewCategoryMenu(){
        if(this.state.menuOpened === true){
            this.setState({menuOpened: false}, () => {
                this.setState({errorNewCategoryCreationAlreadyExists: false});
                this.setState({errorNewCategoryCreationGeneric: false});
            });
            this.setState({newCategoryName: ""});
            this.setState({newCategoryColor: "#2E7FF9"})
        }
    }

    private handleNewCategoryNameKeyDown(event: any){
        if(AppUtils.isPhoneOrTablet()){
            if (event.key === 'Enter') {
                console.log("[CategoryButton] Done clicked!");
                if(this.newCategoryNameInput !== undefined){
                    this.newCategoryNameInput.current.blur();
                }
            }
        }
    }
    
    private handleNewCategoryNameChanges(event: any){
        if(event.target.value.length <= 30){
            this.setState({errorNewCategoryCreationAlreadyExists: false});
            this.setState({errorNewCategoryCreationGeneric: false});
            this.setState({newCategoryName: event.target.value}, () => {
                this.setState({buttonNewCategoryDisabled: (this.state.newCategoryName.length === 0)})
            });
            let computedLength = this.MAX_CATEGORY_NAME_LENGTH - event.target.value.length;
            this.setState({newCategoryNameRemainingLength: computedLength});
        } else {
            event.preventDefault();
        }
    }

    private handleNewCategoryColorChanges(event: any){
        console.log("[CategoryButton] handleNewCategoryColorChanges " + event.target.value);
        this.setState({newCategoryColor: event.target.value});
    }

    private handleResizeViewForActionsMenu(){
        if(AppUtils.isPhoneOrTablet()){
            if(this.state.menuOpened){
                let element = document.getElementById('category-create-new-button');
                let top = element?.offsetTop;

                let newTop = top!! - (373 + 5);
                this.setState({topNewCategoryMenu: newTop});
                this.setState({leftNewCategoryMenu: 20});

                let topButton = $("#category-create-new-button").offset()?.top !== undefined ? $("#category-create-new-button").offset()?.top! : 0;
                let computedTop = (topButton > 373) ?  (topButton - 373) : topButton;
                window.scrollTo({
                    top: computedTop,
                    behavior: 'smooth'
                });
            } else {
                if(this.state.menuCategoryOpened || this.state.menuUpdateOpened){
                    let divName = this.props.category!.categoryId!;
                    let element = document.getElementById(divName);
                    let left = element?.offsetLeft;
                    let top = element?.offsetTop;
    
                    let newTop = (top !== undefined) ? (top + 180 + 10) : 0;
                    let newLeft = (left !== undefined) ? (left) : 0;
    
                    this.setState({topCategoryMeatballMenu: newTop});
                    this.setState({leftCategoryMeatballMenu: newLeft});

                    window.scrollTo({
                        top: newTop - 190,
                        behavior: 'smooth'
                    });
                }
            }
        } else {
            if(this.state.menuOpened){
                // New category
                let element = document.getElementById('category-create-new-button');
                let left = element?.offsetLeft;
                let top = element?.offsetTop;
                let place = this.props.place;
                console.log("Element new category button " + left + " " + top +  " " + place);
                if(place === 1){
                    // left column, use right
                    if(left!! > 0){
                        // 294 + 2 border is the widht of the category button
                        // 10 is the margin from button and container
                        left = left!! + 296 + 10;
                    }
                    this.setState({topNewCategoryMenu: top});
                    this.setState({leftNewCategoryMenu: left});
                } else if(place === 2){
                    // center column, use right
                    if(left!! > 0){
                        // 294 + 2 border is the widht of the category button
                        // 10 is the margin from button and container
                        left = left!! + 296 + 10;
                    }
                    this.setState({topNewCategoryMenu: top});
                    this.setState({leftNewCategoryMenu: left});
                } else {
                    // right column, use left
                    if(left!! > 0){
                        // 335 is the widht of the new container
                        // 10 is the margin from button and container
                        left = left!! - 335 - 10;
                    }
                    this.setState({topNewCategoryMenu: top});
                    this.setState({leftNewCategoryMenu: left});
                }
            } else {
                if(this.state.menuCategoryOpened || this.state.menuUpdateOpened){
                    // Category menu opened
                    let divName = this.props.category!.categoryId!
                    let element = document.getElementById(divName);
                    let left = element?.offsetLeft;
                    let top = element?.offsetTop;
                    let place = this.props.place;
                    if(place === 1){
                        // left column, use right
                        if(left!! > 0){
                            // 290 is the widht of the category button
                            // 10 is the margin from button and container
                            left = left!! + 290 + 10;
                        }
                        this.setState({topCategoryMeatballMenu: top});
                        this.setState({leftCategoryMeatballMenu: left});
                    } else if(place === 2){
                        // center column, use right
                        if(left!! > 0){
                            // 290 is the widht of the category button
                            // 10 is the margin from button and container
                            left = left!! + 290 + 10;
                        }
                        this.setState({topCategoryMeatballMenu: top});
                        this.setState({leftCategoryMeatballMenu: left});
                    } else {
                        // right column, use left
                        if(left!! > 0){
                            // 335 is the widht of the new container
                            // 10 is the margin from button and container
                            left = left!! - 335 - 10;
                        }
                        this.setState({topCategoryMeatballMenu: top});
                        this.setState({leftCategoryMeatballMenu: left});
                    }
                }
            }
        }
    }
    // ------END NEW CATEGORY Management 

    // ------Category meatball menu 

    private openMeatballMenu(category?: ICategoryDto, place?: number){
        console.log("[CategoryButton] openMeatballMenu");
        if(this.state.menuCategoryOpened === false && (category !== null || category !== undefined)){
            let main = $('#main-container-catalog')
            let mainHeight = main!!.height();
            if(!AppUtils.isPhoneOrTablet()){
                // desktop
                let divName = '#' + this.props.category!.categoryId!
                let left = $(divName).offset()?.left !== undefined ? $(divName).offset()?.left : 0;
                let top = $(divName).offset()?.top;
                
                if(place === 1){
                    // left column, use right
                    if(left!! > 0){
                        // 290 is the widht of the category button
                        // 10 is the margin from button and container
                        left = left!! + 290 + 10;
                    }
                    this.setState({topCategoryMeatballMenu: top});
                    this.setState({leftCategoryMeatballMenu: left});
                } else if(place === 2){
                    // center column, use right
                    if(left!! > 0){
                        // 290 is the widht of the category button
                        // 10 is the margin from button and container
                        left = left!! + 290 + 10;
                    }
                    this.setState({topCategoryMeatballMenu: top});
                    this.setState({leftCategoryMeatballMenu: left});
                } else {
                    // right column, use left
                    if(left!! > 0){
                        // 335 is the widht of the new container
                        // 10 is the margin from button and container
                        left = left!! - 335 - 10;
                    }
                    this.setState({topCategoryMeatballMenu: top});
                    this.setState({leftCategoryMeatballMenu: left});
                }

                main.height(mainHeight!!.toString());
            } else {
                // mobile, on bottom of the button category
                let divName = '#' + this.props.category!.categoryId!
                let left = $(divName).offset()?.left !== undefined ? $(divName).offset()?.left : 0;
                let top = $(divName).offset()?.top;

                let newTop = (top !== undefined) ? (top + 180 + 10) : 0;
                let newLeft = (left !== undefined) ? (left) : 0;

                this.setState({topCategoryMeatballMenu: newTop});
                this.setState({leftCategoryMeatballMenu: newLeft});

                $([document.documentElement, document.body]).animate({
                    scrollTop: $(divName).offset()?.top
                }, 350);

                main.height(mainHeight!!.toString());
            }

            let divName = '#' + this.props.category!.categoryId!
            $(divName).addClass('category-button-ontop');
            sessionStorageInstance.setData('categoryButtonTop', divName);
            this.setState({errorUpdateCategoryAlreadyExists: false});
            this.setState({errorUpdateCategoryGeneric: false});
            this.setState({buttonUpdateCategoryDisabled: true});
            this.setState({menuCategoryOpened: true});
            this.setState({menuUpdateOpened: false});
        } 
    }

    private closeMeatballMenu(){
        console.log("[CategoryButton] closeMeatballMenu");
        this.setState({menuCategoryOpened: false});
        this.setState({menuUpdateOpened: false});
        this.setState({copyFunction: false});
        this.setState({errorUpdateCategoryAlreadyExists: false});
        this.setState({errorUpdateCategoryGeneric: false});
        this.setState({buttonUpdateCategoryDisabled: true});
        let divName = sessionStorageInstance.getData('categoryButtonTop');
        if(divName !== null){
            sessionStorageInstance.removeData('categoryButtonTop');
            $(divName).removeClass('category-button-ontop');
        }
    }

    private openUpdatePopup(){
        this.setState({menuCategoryOpened: false});
        this.setState({menuUpdateOpened: true});
        if(this.props.category !== undefined || this.props.category !== null){
            this.setState({updateCategoryName: this.props.category?.name});
            this.setState({updateCategoryColor: this.props.category?.color});
            let computedLength = this.MAX_CATEGORY_NAME_LENGTH - this.props.category!!.name!!.length;
            this.setState({updateCategoryNameRemainingLength: computedLength});
        }
    }

    private closeUpdatePopup(){
        this.setState({menuCategoryOpened: true});
        this.setState({menuUpdateOpened: false});
        this.setState({copyFunction: false});
        this.setState({errorUpdateCategoryAlreadyExists: false});
        this.setState({errorUpdateCategoryGeneric: false});
        this.setState({buttonUpdateCategoryDisabled: true});
    }

    private closeCopyPopup(){
        this.setState({menuCategoryOpened: false});
        this.setState({menuUpdateOpened: false});
        this.setState({copyFunction: false});
        this.setState({errorUpdateCategoryAlreadyExists: false});
        this.setState({errorUpdateCategoryGeneric: false});
        this.setState({buttonUpdateCategoryDisabled: true});
        let divName = sessionStorageInstance.getData('categoryButtonTop');
        if(divName !== null){
            sessionStorageInstance.removeData('categoryButtonTop');
            $(divName).removeClass('category-button-ontop');
        }
    }

    private openCopyMenu(category: ICategoryDto, place: number, failedName: string){
        let main = $('#main-container-catalog')
            let mainHeight = main!!.height();
            if(!AppUtils.isPhoneOrTablet()){
                // desktop
                let divName = '#' + category!.categoryId!
                let left = $(divName).offset()?.left !== undefined ? $(divName).offset()?.left : 0;
                let top = $(divName).offset()?.top;
                
                if(place === 1){
                    // left column, use right
                    if(left!! > 0){
                        // 290 is the widht of the category button
                        // 10 is the margin from button and container
                        left = left!! + 290 + 10;
                    }
                    this.setState({topCategoryMeatballMenu: top});
                    this.setState({leftCategoryMeatballMenu: left});
                } else if(place === 2){
                    // center column, use right
                    if(left!! > 0){
                        // 290 is the widht of the category button
                        // 10 is the margin from button and container
                        left = left!! + 290 + 10;
                    }
                    this.setState({topCategoryMeatballMenu: top});
                    this.setState({leftCategoryMeatballMenu: left});
                } else {
                    // right column, use left
                    if(left!! > 0){
                        // 335 is the widht of the new container
                        // 10 is the margin from button and container
                        left = left!! - 335 - 10;
                    }
                    this.setState({topCategoryMeatballMenu: top});
                    this.setState({leftCategoryMeatballMenu: left});
                }

                main.height(mainHeight!!.toString());
            } else {
                // mobile, on bottom of the button category
                let divName = '#' + category!.categoryId!
                let left = $(divName).offset()?.left !== undefined ? $(divName).offset()?.left : 0;
                let top = $(divName).offset()?.top;

                let newTop = (top !== undefined) ? (top + 180 + 10) : 0;
                let newLeft = (left !== undefined) ? (left + 3) : 0;

                this.setState({topCategoryMeatballMenu: newTop});
                this.setState({leftCategoryMeatballMenu: newLeft});

                $([document.documentElement, document.body]).animate({
                    scrollTop: $(divName).offset()?.top
                }, 350);

                main.height(mainHeight!!.toString());
            }

            this.setState({menuUpdateOpened: true});
            this.setState({updateCategoryName: failedName.substring(0, 30)});
            this.setState({updateCategoryColor: category?.color});
            let computedLength = this.MAX_CATEGORY_NAME_LENGTH - failedName.substring(0, 30).length;
            this.setState({updateCategoryNameRemainingLength: computedLength});
            this.setState({copyCategory: category})
            let divName = '#' + category!.categoryId!;
            sessionStorageInstance.setData('categoryButtonTop', divName);
            $(divName).addClass('category-button-ontop');
    }

    private handleUpdateCategoryNameKeyDown(event: any){
        if(AppUtils.isPhoneOrTablet()){
            if (event.key === 'Enter') {
                console.log("[CategoryButton] Done clicked!");
                if(this.updateCategoryNameInput !== undefined){
                    this.updateCategoryNameInput.current.blur();
                }
            }
        }
    }
    
    private handleUpdateCategoryNameChanges(event: any){
        this.setState({errorUpdateCategoryAlreadyExists: false});
        this.setState({errorUpdateCategoryGeneric: false});
        this.setState({updateCategoryName: event.target.value}, () => {
            this.setState({buttonUpdateCategoryDisabled: (this.state.updateCategoryName.length === 0)})
        });
        let computedLength = this.MAX_CATEGORY_NAME_LENGTH - event.target.value.length;
        this.setState({updateCategoryNameRemainingLength: computedLength});
    }

    private handleUpdateCategoryColorChanges(event: any){
        this.setState({updateCategoryColor: event.target.value});
        this.setState({buttonUpdateCategoryDisabled: false});
    }

    // ------END Category meatball menu
    
    private hideHelperText(input: string){
        $('#' + input).css('visibility', 'hidden');
    }

    private showHelperText(input: string){
        $('#' + input).css('visibility', 'visible');
    }

    // Meatball menu content render
    private renderMainMenu(): JSX.Element {
        return <div className={'category-meatball-menu-container'} style={{top: this.state.topCategoryMeatballMenu, left: this.state.leftCategoryMeatballMenu}}>
                <div className={"category-menu-options-main-content"}>
                <div style={{width: '100%'}} id={"category-menu-options-inner-content"}>
                    <div className={"category-menu-options-main-title-content"}>
                        <p className={"category-menu-options-main-title"}>Cosa vuoi fare?</p>
                        <div onClick={() => this.closeMeatballMenu()} style={{cursor: 'pointer'}}>
                            <CloseMenuIcon widht={'20px'} height={'20px'} fill={'#000000'}/>
                        </div>
                    </div>
                </div>
                <div className={"category-meatball-row"}></div>
                {
                    this.props.category?.name?.toLowerCase() !== "senza categoria" ? [
                        <p className={"category-menu-link"} onClick={() => this.props.goToPage()}>{"Visualizza info categoria".toUpperCase()}</p>,
                        <p className={"category-menu-link"} onClick={() => this.openUpdatePopup()}>{"Modifica Nome categoria".toUpperCase()}</p>,
                        <p className={"category-menu-link"} onClick={() => this.props.copyCategory()}>{"Duplica categoria".toUpperCase()}</p>,
                        <p className={"category-menu-link"} onClick={() => this.props.addProductCallback()}>{"Aggiungi prodotto".toUpperCase()}</p>
                    ] : [
                        <p className={"category-menu-link"} onClick={() => this.props.goToPage()}>{"Visualizza info categoria".toUpperCase()}</p>
                    ]
                }
                
                <div className={"category-meatball-row"}></div>
                <div className={"category-meatball-radio-color-container"}>
                    {
                        _.map(colors.colors, (value: object, index: number) => {
                            // @ts-ignore
                            let key: string = value['key'];
                            // @ts-ignore
                            let hexValue: string = value['value'];
                            return (
                                <div key={key} className={index === 0 ? 'insert-new-category-radio-content-first' : index === (colors.colors.length - 1) ? 'insert-new-category-radio-content-last' : 'insert-new-category-radio-content'}>
                                    {
                                        <div className="radio-input-container">
                                            <Radio disableRipple color="default"
                                                checked={this.props.category?.color === hexValue} value={hexValue} onChange={() => {this.props.changeColorFromMenu(
                                                    this.props.category?.categoryId, hexValue
                                                )}}
                                                checkedIcon={<span className={"radio-icon radio-checked-icon"} style={{backgroundColor: hexValue}} />}
                                                icon={<span className={"radio-icon"} style={{backgroundColor: hexValue}} />}/>
                                        </div>
                                    }
                                </div>
                            );
                        })
                    }
                </div>
                <div className={"category-meatball-row"}></div>
                {
                    this.props.category?.name?.toLowerCase() !== "senza categoria" ? [
                        <p className={"category-menu-link-red"} onClick={() => this.props.deleteCategory()}>ELIMINA</p>
                    ] : [
                        <p className={"category-menu-link-red"} onClick={() => this.props.deleteAllProductsInNoCategory()}>ELIMINA PRODOTTI</p>
                    ]
                }
                </div> 
        </div>
    }

    private renderUpdateMenu(): JSX.Element {
        return <div id={this.props.category?.categoryId + "_update"} className={'category-menu-container'} style={{top: this.state.topCategoryMeatballMenu, left: this.state.leftCategoryMeatballMenu}}>
            <div className={"category-menu-options-main-content"}>
                <div style={{width: '100%'}} id={"category-menu-options-inner-content"}>
                    <div className={"category-menu-options-main-title-content"}>
                        <p className={"category-menu-options-main-title"}>{this.state.copyFunction ? "Duplica categoria" : "Modifica nome categoria"}</p>
                        <div onClick={() => this.state.copyFunction ? this.closeCopyPopup() : this.closeUpdatePopup()} style={{cursor: 'pointer'}}>
                            <CloseMenuIcon widht={'20px'} height={'20px'} fill={'#000000'}/>
                        </div>
                    </div>
                    <div className={"category-menu-options-main-row-content"}></div>
                    <TextField id={"update-category-name-field"} label="Inserisci nome categoria" type={"text"}
                        inputRef={this.updateCategoryNameInput} onKeyDown={this.handleUpdateCategoryNameKeyDown} inputProps={{ maxLength: this.MAX_CATEGORY_NAME_LENGTH }}
                        value={this.state.updateCategoryName}
                        error={this.state.errorUpdateCategoryAlreadyExists || this.state.errorUpdateCategoryGeneric}
                        onChange={this.handleUpdateCategoryNameChanges}
                        helperText={"-" + this.state.updateCategoryNameRemainingLength}
                        onFocus={() => this.showHelperText('update-category-name-field-helper-text')}
                        onBlur={() => this.hideHelperText('update-category-name-field-helper-text')}
                    />
                    { this.state.errorUpdateCategoryAlreadyExists && <p className={"insert-new-category-error-message"}>
                        Nome categoria già esistente. Inseriscine un altro.
                    </p> }
                    { this.state.errorUpdateCategoryGeneric && <p className={"insert-new-category-error-message"}>
                        {this.state.copyFunction ? "Si è verificato un errore durante la duplicazione della categoria." : "Si è verificato un errore durante la modifica della categoria."}
                    </p> }
                    <p className={(this.state.errorUpdateCategoryAlreadyExists || this.state.errorUpdateCategoryGeneric) ? "insert-new-category-color-label-with-error" : "insert-new-category-color-label"}>Scegli un colore per la categoria</p>
                    <div className={"insert-new-category-radio-color-container"}>
                            {
                                _.map(colors.colors, (value: object, index: number) => {
                                    // @ts-ignore
                                    let key: string = value['key'];
                                    // @ts-ignore
                                    let hexValue: string = value['value'];
                                    return (
                                        <div key={key} className={index === 0 ? 'insert-new-category-radio-content-first' : index === (colors.colors.length - 1) ? 'insert-new-category-radio-content-last' : 'insert-new-category-radio-content'}>
                                            {
                                                <div className="radio-input-container">
                                                    <Radio disableRipple color="default"
                                                        checked={this.state.updateCategoryColor === hexValue} value={hexValue} onChange={this.handleUpdateCategoryColorChanges}
                                                        checkedIcon={<span className={"radio-icon radio-checked-icon"} style={{backgroundColor: hexValue}} />}
                                                        icon={<span className={"radio-icon"} style={{backgroundColor: hexValue}} />}/>
                                                </div>
                                            }
                                        </div>
                                    );
                                })
                            }
                    </div>
                    <Button id={"update-category-button-create"} disableRipple disableFocusRipple disableTouchRipple disabled={this.state.copyFunction ? false : this.state.buttonUpdateCategoryDisabled} onClick={() => {
                                this.state.copyFunction ? this.props.copyCategoryWithValue(this.props.category?.categoryId ,this.state.updateCategoryName, this.state.updateCategoryColor)
                                : this.props.updateCategory(this.props.category?.categoryId ,this.state.updateCategoryName, this.state.updateCategoryColor);
                            }}>{this.state.copyFunction ? "DUPLICA CATEGORIA" : "MODIFICA CATEGORIA"}</Button>
                </div>
            </div>
        </div>
    }
    // -----END Meatball menu content render

    render(){
        return this.props.category !== undefined ? this.props.category !== null ?
        <div>
            {(this.state.menuCategoryOpened || this.state.menuUpdateOpened) && <div id={this.props.category.categoryId + "_overlay"} className={"overlay-class"}></div> /* Overlay div */}
            {
                /* meatball category menu */ [this.state.menuCategoryOpened && this.renderMainMenu(), this.state.menuUpdateOpened && this.renderUpdateMenu()]
            }
            <div id={this.props.category!.categoryId!} className={"category-main-container"} 
                style={{backgroundColor: this.props.category!!.color!!}}>
                <div className={"category-main-content-info"}>
                    <div className={"category-main-content-info-content"}>
                        <div className={"category-main-content-info-content-name"}>
                            <p className={"category-main-content-info-name"}>{this.props.category!!.name}</p>
                        </div>
                        <div className={"category-main-content-info-content-products"}>
                            <p className={"category-main-content-info-label"}>Prodotti inseriti</p>
                            <p className={"category-main-content-info-counter"}>{
                                this.props.category!!.nProducts
                            }</p>
                        </div>
                    </div>
                </div>
                <div className={"category-main-content-buttons"}>
                    <div className={"category-main-content-info-content"}>
                        <div className={"category-main-content-button-dots"} onClick={() => this.openMeatballMenu(this.props.category!!, this.props.place)}>
                            <Dots className={"category-info-dots-icon"}/>
                        </div>
                        <div className={"category-main-content-button-arrow"} onClick={() => this.props.goToPage()}>
                            <Arrow className={"category-info-arrow-icon"} />
                        </div>
                    </div>
                </div>
    </div>
    </div> : <div>
        </div> : <div>
                    {this.state.menuOpened && <div className={"overlay-class"}></div> /* Overlay div */}
                <div>
                {/* new category menu */ this.state.menuOpened && <div className={'category-menu-container'} style={{top: this.state.topNewCategoryMenu, left: this.state.leftNewCategoryMenu}}>
                        <div className={"category-menu-options-main-content"}>
                            <div style={{width: '100%'}} id={"category-menu-options-inner-content"}>
                                <div className={"category-menu-options-main-title-content"}>
                                    <p className={"category-menu-options-main-title"}>Crea la categoria prodotti</p>
                                    <div onClick={() => this.closeNewCategoryMenu()} style={{cursor: 'pointer'}}>
                                        <CloseMenuIcon widht={'20px'} height={'20px'} fill={'#000000'}/>
                                    </div>
                                </div>
                                <div className={"category-menu-options-main-row-content"}></div>
                                <TextField id={"insert-new-category-name-field"} label="Inserisci nome categoria" type={"text"}
                                    inputRef={this.newCategoryNameInput} onKeyDown={this.handleNewCategoryNameKeyDown} inputProps={{ maxLength: this.MAX_CATEGORY_NAME_LENGTH }}
                                    value={this.state.newCategoryName}
                                    error={this.state.errorNewCategoryCreationAlreadyExists || this.state.errorNewCategoryCreationGeneric}
                                    onChange={this.handleNewCategoryNameChanges}
                                    helperText={"-" + this.state.newCategoryNameRemainingLength}
                                    onFocus={() => this.showHelperText('insert-new-category-name-field-helper-text')}
                                    onBlur={() => this.hideHelperText('insert-new-category-name-field-helper-text')}
                                />
                                { this.state.errorNewCategoryCreationAlreadyExists && <p className={"insert-new-category-error-message"}>
                                    Nome categoria già esistente. Inseriscine un altro.
                                </p> }
                                { this.state.errorNewCategoryCreationGeneric && <p className={"insert-new-category-error-message"}>
                                    Si è verificato un errore durante la creazione della nuova categoria.
                                </p> }
                                <p className={(this.state.errorNewCategoryCreationAlreadyExists || this.state.errorNewCategoryCreationGeneric) ? "insert-new-category-color-label-with-error" : "insert-new-category-color-label"}>Scegli un colore per la categoria</p>
                                <div className={"insert-new-category-radio-color-container"}>
                                        {
                                            _.map(colors.colors, (value: object, index: number) => {
                                                // @ts-ignore
                                                let key: string = value['key'];
                                                // @ts-ignore
                                                let hexValue: string = value['value'];
                                                return (
                                                    <div key={key} className={index === 0 ? 'insert-new-category-radio-content-first' : index === (colors.colors.length - 1) ? 'insert-new-category-radio-content-last' : 'insert-new-category-radio-content'}>
                                                        {
                                                            <div className="radio-input-container">
                                                                <Radio disableRipple color="default"
                                                                    checked={this.state.newCategoryColor === hexValue} value={hexValue} onChange={this.handleNewCategoryColorChanges}
                                                                    checkedIcon={<span className={"radio-icon radio-checked-icon"} style={{backgroundColor: hexValue}} />}
                                                                    icon={<span className={"radio-icon"} style={{backgroundColor: hexValue}} />}/>
                                                            </div>
                                                        }
                                                    </div>
                                                );
                                            })
                                        }
                                </div>
                                <Button id={"insert-new-category-button-create"} disableRipple disableFocusRipple disableTouchRipple disabled={this.state.buttonNewCategoryDisabled} onClick={() => {
                                            this.props.onNewCategoryClick(this.state.newCategoryName, this.state.newCategoryColor);
                                        }}>CREA CATEGORIA</Button>
                            </div>
                        </div>
                    </div>}
                    {/* new category button */}
                    <div id={"category-create-new-button"} className={this.state.menuOpened ? "category-create-new category-create-new-on-top" : "category-create-new"} 
                        style={{cursor: 'pointer'}} onClick={() => this.openNewCategoryMenu()}>
                        <div className={"category-create-new-text-container"}>
                            <p className={"category-create-new-text"}>{"CREA Categoria".toUpperCase()}</p>
                        </div>
                    </div>
                </div>
        </div>
    }
}